import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Container,
    Row,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from 'reactstrap';
import { AvForm, AvGroup, AvField } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../i18next';

import { MENUU_ADMIN, MENUU_MASTER_ADMIN, LOW, MEDIUM, HIGH } from '../../utils/Constants';
import {
    pauseAllRestaurants,
    canUserAccessPauseAllRestaurants,
    resetUserAccessPauseAllRestaurants
} from '../../actions/index';

class PausingScreen extends Component {
    constructor() {
        super();

        this.state = {
            userCode: null,
            pauseAllModal: false,
            isOpen: false,
            restaurantPriority: null
        }
    }

    togglePauseAllWarningModal = () => {
        this.setState({
            ...this.state,
            pauseAllModal: !this.state.pauseAllModal
        }, () => {
            if (!this.state.pauseAllModal) {
                this.props.resetUserAccessPauseAllRestaurants();
                this.setState({
                    ...this.state,
                    userCode: null
                })
            }
        })
    }

    changeCodeState = ({ target }) => {

        this.setState({
            ...this.state,
            [target.name]: target.value
        });
    }

    renderPasswordVerification = () => {

        return (
            <AvForm onValidSubmit={() => this.props.canUserAccessPauseAllRestaurants(this.state.userCode)}>
                <AvGroup>
                    <span className='codeVerification'><MaterialIcon icon="lock" size={20} color="#a9a9a9" />
                        <AvField
                            style={{ paddingLeft: 36 }}
                            placeholder={i18n.t('screens:restaurantsScreen.secretCode')}
                            type="password" name="userCode" id="password"
                            value={this.state.userCode}
                            onChange={this.changeCodeState}
                            required
                            errorMessage={i18n.t('common:validations.errorMsg')}
                        />
                    </span>
                </AvGroup>
            </AvForm>
        );
    }

    renderHeading = () => {
        const { screenHeading } = styles;

        return (
            <div style={screenHeading}>
                <MaterialIcon icon="pause" color="#0288d1" size={22} />&nbsp;
                {i18n.t('screens:systemControlContainer.headingRestaurants')}
            </div>
        );
    }

    renderPauseAllRestaurantsWarningModal() {
        const { canAccessPauseAllRestaurants } = this.props.user;
        let priorityLevel;
        switch (this.state.restaurantPriority) {
            case LOW:
                priorityLevel = 3
                break;
            case MEDIUM:
                priorityLevel = 2
                break;
            case HIGH:
                priorityLevel = 1
                break;
        }
        const confirmationText = this.state.restaurantPriority ? `${i18n.t('screens:restaurantsScreen.pauseLevelConfirmationText')}${priorityLevel}` : i18n.t('screens:restaurantsScreen.pauseAllConfirmationText');

        return (
            <Modal isOpen={this.state.pauseAllModal} toggle={this.togglePauseAllWarningModal}>
                <ModalHeader className="modalHeader" toggle={this.togglePauseAllWarningModal}>
                    {!canAccessPauseAllRestaurants ? i18n.t('screens:restaurantsScreen.enterSecretCode') : i18n.t('screens:restaurantsScreen.pauseAllRestaurants')}
                </ModalHeader>
                <ModalBody>
                    {!canAccessPauseAllRestaurants ? this.renderPasswordVerification() : confirmationText}
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        onClick={!canAccessPauseAllRestaurants ? () => this.props.canUserAccessPauseAllRestaurants(this.state.userCode) : () => this.props.pauseAllRestaurants(this.state.restaurantPriority, this.togglePauseAllWarningModal)}>
                        <MaterialIcon icon="check" color="#fff"
                            size={20} />&nbsp;{i18n.t('common:buttons.confirm')}
                    </Button>{' '}
                    <Button color="outline-primary" onClick={this.togglePauseAllWarningModal}>{i18n.t('common:buttons.cancel')}</Button>
                </ModalFooter>
            </Modal>
        );
    }

    render() {

        const { containerStyle } = styles;

        return (
            <Container fluid style={containerStyle}>
                <Row>{this.renderHeading()}</Row>
                {
                    (this.props.currentlyLoggedInUser.role === MENUU_MASTER_ADMIN || this.props.currentlyLoggedInUser.role === MENUU_ADMIN) &&
                    <div style={{ display: 'flex' }}>
                        <AvForm>
                            <AvGroup>
                                <label htmlFor="restaurantPriority">{i18n.t('screens:generalScreen.priorityLevel')}</label>
                                <AvField
                                    type="select"
                                    name="restaurantPriority"
                                    id="restaurantPriority"
                                    style={{ width: 150 }}
                                    value={this.state.restaurantPriority}
                                    onChange={this.changeCodeState}
                                >
                                    <option value="">{i18n.t('screens:restaurantsScreen.all')}</option>
                                    <option value={LOW}>{i18n.t('screens:generalScreen.low')}</option>
                                    <option value={MEDIUM}>{i18n.t('screens:generalScreen.medium')}</option>
                                    <option value={HIGH}>{i18n.t('screens:generalScreen.high')}</option>
                                </AvField>
                            </AvGroup>
                        </AvForm>
                        <Button
                            style={{ margin: '0 0 10px 20px', alignSelf: 'flex-end' }}
                            color='primary'
                            onClick={this.togglePauseAllWarningModal}>
                            {i18n.t('screens:restaurantsScreen.pauseAllRestaurantsButton')}
                        </Button>
                    </div>
                }
                {
                    this.state.pauseAllModal ?
                        this.renderPauseAllRestaurantsWarningModal() : null
                }
            </Container>
        );
    }
}

const mapStateToProps = state => {

    return {
        currentlyLoggedInUser: state.user,
        user: state.user,
        resendOrders: state.resendOrders
    }
};

export default connect(mapStateToProps, {
    pauseAllRestaurants,
    canUserAccessPauseAllRestaurants,
    resetUserAccessPauseAllRestaurants
})(PausingScreen);

let styles = {
    containerStyle: {
        marginLeft: 0,
        marginBottom: 25,
        backgroundColor: '#fafafa',
        borderLeft: '1px solid #0288d1',
        padding: 10
    },
    screenHeading: {
        display: 'flex',
        borderBottom: '1px solid rgb(222, 226, 230)',
        marginBottom: 20,
        marginLeft: 15,
        paddingLeft: 0,
        color: '#0288d1',
        width: 299
    }
};


// WEBPACK FOOTER //
// ./src/components/systemControl/PausingScreen.js